import React from 'react';
import { Checkbox } from '@material-ui/core';
import { Field, useFormikContext } from 'formik';

export default function CheckboxAtualizarSomente(){
    const { values, setFieldValue } = useFormikContext();

    function handleChangeAtualizarSomente(value){
        setFieldValue('valorBase', '');

        switch(value){
        case 'status':
            setFieldValue('atualizarSomenteStatus', !values.atualizarSomenteStatus);
            setFieldValue('atualizarSomenteValorDesconto', false);
            setFieldValue('valorDesconto', '');
            setFieldValue('dataInicioDesconto', '');
            setFieldValue('dataFinalDesconto', '');
            setFieldValue('pagamentoCartao', '');
            setFieldValue('pagamentoBoleto', '');
            setFieldValue('pagamentoEscelsa', '');
            setFieldValue('formasPagamento', '');
            break;
        case 'desconto':
            setFieldValue('atualizarSomenteStatus', false);
            setFieldValue('atualizarSomenteValorDesconto', !values.atualizarSomenteValorDesconto);
            break;
        default:
            break;
        }
    }

    return <>
        <div>
            <Field
                as={Checkbox}
                name='atualizarSomenteValorDesconto'
                id='atualizarSomenteValorDesconto'
                color='primary'
                checked={values.atualizarSomenteValorDesconto}
                onChange={handleChangeAtualizarSomente.bind(this, 'desconto')}
            />
            <label htmlFor="somentePercentual" className="p-checkbox-label">Atualizar somente valor desconto</label>
        </div>

        <div>
            <Field
                as={Checkbox}
                name='atualizarSomenteStatus'
                id='atualizarSomenteStatus'
                color='primary'
                checked={values.atualizarSomenteStatus}
                onChange={handleChangeAtualizarSomente.bind(this, 'status')}
            />
            <label htmlFor="atualizarSomenteStatus" className="p-checkbox-label">Atualizar somente o status</label>
        </div>
    </>;
}
